import { Component, ElementRef } from '@angular/core';
import { DesignAttributeType, AttributeChangeEventArgsType, OptionsAttribute } from '../../../../types/designer-attribute-type';
import { BaseDesignerComponent } from '../../base/base-designer-component';

@Component({
  selector: 'sx-title-designer',
  templateUrl: './title.designer.component.html'
})

export class SxTitleDesigner extends BaseDesignerComponent {
  constructor(container: ElementRef) {
    super(container, 'SxTitle');
  }

  loadDefaults(): void {
    super.loadDefaults();
    this.controlContext.title = 'title';
    this.controlContext.size = 'medium';
  }

  loadState(controlContext: any) {
    super.loadState(controlContext);
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();

    info['title'] = this.controlContext.title;
    info['size'] = this.controlContext.size;
    info['textType'] = this.controlContext.textType;

    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();

    const titleAtt = new DesignAttributeType(this.controlContext, 'title', 'title', 'Title');

    const types = [
      { id: 'staticFlat', name: 'Static' },
      { id: 'staticReplace', name: 'Static Replace' },
     // { id: 'staticJS', name: 'Static JS' },
      //      { id: 'dynamicJS', name: 'Dynamic JS' },
    ];
    const type = new OptionsAttribute(this.controlContext, types, 'textType', 'Title display Type');

    const sizes = [
      { id: 'small', name: 'Small' },
      { id: 'medium', name: 'Medium' },
      { id: 'large', name: 'Large' }
    ];
    const sizeAtt = new OptionsAttribute(this.controlContext, sizes, 'size', 'Size');
    sizeAtt.change.subscribe(v => this.onSizeAttChange(v));

    this.attributes.push(titleAtt);
    this.attributes.push(type);
    this.attributes.push(sizeAtt);
  }

  onSizeAttChange(args: AttributeChangeEventArgsType): void {
    this.controlContext.size = args.newValue;
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/text-editors/title.designer.component.ts